import axios from 'axios';

const config = {
	headers: {
		'x-access-token': sessionStorage.token,
	},
};

let host = 'http://localhost:8000/';
if (process.env.NODE_ENV === 'production') {
	host = 'https://reale-server.herokuapp.com/';
}
const url = `${host}api/mapinfo`;

const getAllPoints = () =>
	// console.log(sessionStorage['token']);
	axios.get(url, config);

const getPoint = (id: string) => axios.get(`${url}/${id}`, config);

const addPoint = (obj: any) => axios.post(url, obj, config);

const updatePoint = (id: string, obj: any) =>
	axios.put(`${url}/${id}`, obj, config);

const deletePoint = (id: string) => axios.delete(`${url}/${id}`, config);

// //ONLY FOR LANDING PAGE - OPEN TO ALL
// const getLandingJob = (id) => {
// 	return axios.get(url2 + '/' + id);
// };

export default {
	getAllPoints,
	getPoint,
	addPoint,
	updatePoint,
	deletePoint,
};
